import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppShell } from '../components/AppShell.tsx'
import { meQuery } from '../lib/api.ts'

/** Authenticated area. Unauthenticated users are sent to /login with a redirect back. */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery)
    if (!me) throw redirect({ to: '/login', search: { redirect: location.href } })
    return { me }
  },
  component: AppShell,
})
